/**
 * Timbrica Sidebar — accordion groups, ranked search.
 * Reads config from window.__SIDEBAR_CFG (set inline by PHP).
 */
(function(){
    /* Нонс СВОЕГО тега — снимаем на верхнем уровне, пока идёт синхронное
     * выполнение: `document.currentScript` живёт только здесь, из колбэка он
     * уже null. Нужен ниже, для <script type="speculationrules">.
     * Читаем IDL-свойство, а НЕ getAttribute: браузер прячет content-атрибут
     * (nonce hiding), и `getAttribute('nonce')` вернёт пустую строку.
     * Запасной путь загрузки не теряет его — __jsFallback копирует .nonce на
     * пересозданный элемент. */
    var CSPN='';try{CSPN=(document.currentScript&&document.currentScript.nonce)||''}catch(e){}
    var cfg=window.__SIDEBAR_CFG;
    if(!cfg)return;
    var sb=document.getElementById('toolSidebar');if(!sb)return;
    var si=document.getElementById('sbSearch'),nav=document.getElementById('sbNav');
    var bg=document.getElementById('sbBurger');
    var ov=document.getElementById('sbOverlay');
    var srBox=document.getElementById('sbSearchResults');
    var loc=cfg.locale;

    // Ranked search — the SAME index + engine as the header dropdown and
    // /search (search-engine.js, /api/search-data). Until 2026-08-05 this box
    // was a substring FILTER over the nav list in DOM order: every tool whose
    // keywords contained the query stayed visible, so catalog position decided
    // «relevance» — «конвер» ranked BIN/CUE → ISO above Конвертер файлов.
    // Until the index is ready (or if it never arrives — offline PWA), the
    // legacy filter below still runs against visible labels: degraded
    // ordering, never a dead search.
    //
    // The index lives in the page's ONE search thread (search-thread.js), not
    // here. Until 23.10.2026 this file fetched it and ran TimbricaSearch.prepare
    // on the main thread at the first letter typed: 1.9 s of stemming in one
    // piece at CPU ×4, every following key waited behind it (INP 2.4–2.8 s; a
    // 4 GB laptop got 6.5 s), and on the home page the same index was already
    // prepared in the assistant's thread. docs/why/search.md («Один поток поиска на страницу»).
    function warmSearch(){
        var T=window.__searchThread;
        if(T)T.start('sb');
    }
    /* «Ищем…» между первым нажатием и приходом индекса. Пока он едет, ниже
       работает подстрочный фильтр по названиям, а «не найдено» не рисуется:
       на медленном канале индекс идёт секунды, и человек видел либо пустую
       колонку, либо преждевременное «инструмент не найден» (2026-09-11). */
    var sbSt=document.getElementById('sbSearchStatus');
    function setSearching(on){if(sbSt)sbSt.classList.toggle('on',!!on);}
    function kwOf(it){
        return it.textContent.toLowerCase();
    }
    if(si){
        si.addEventListener('focus',warmSearch,{once:true});
        si.addEventListener('input',warmSearch,{once:true});
        // Намерение искать видно раньше первого символа: курсор над полем на
        // десктопе, открытое меню на телефоне — индекс успевает подготовиться
        // в потоке до того, как его спросят.
        si.addEventListener('pointerenter',warmSearch,{once:true});
        si.addEventListener('touchstart',warmSearch,{once:true,passive:true});
    }
    if(bg)bg.addEventListener('click',warmSearch,{once:true});

    // Sentry FH: `Cannot read properties of undefined (reading 'forEach')`.
    // ВОСПРОИЗВЕДЕНО на живой странице подменой конфига: отсутствующий ключ
    // `unlisted` даёт ровно это сообщение, `unlisted: null` — уже другое
    // («of null»), а целый конфиг — ноль ошибок. То есть падало на форме
    // значения, а не на его содержимом.
    //
    // Поиск в этом файле объявлен прогрессивным улучшением («degraded
    // ordering, never a dead search»), и шейп-гейт у индекса поиска уже стоит
    // строкой выше. Здесь его не было — и одно поле роняло всё меню.
    var unlistedTools=Array.isArray(cfg.unlisted)?cfg.unlisted:[];

    /* ⚠️ Sentry FH («Cannot read properties of undefined (reading 'forEach')»)
       не назвал виновника и со второй попытки. Диагностика от 26.08 стоит в
       синхронном try вокруг ФИЛЬТРА — и молчит: событие 02.09 пришло из файла,
       где она заведомо есть (проверено прямо: отданный js-min содержит и
       sb_filter_undef, и дописывание сообщения), а суффикса в тексте нет.
       Значит отказ случается ВНЕ того блока, а sourcemap показывает соседа —
       про его приблизительность сказано ниже.

       Поэтому: маркер области (одна переменная, обновляется перед каждым
       обходом) + слушатель window.error, снимающий состояние ГДЕ БЫ отказ ни
       произошёл. Ошибка не подавляется и летит как летела. */
    var _sbWhere = 'boot';
    /* Состояние сайдбара в момент отказа — для Sentry FH. Первая версия
       дописывала его в ev.error.message из слушателя window.error, и НИ ОДНО
       из шести событий за 22 дня суффикса не принесло: Sentry регистрирует
       свой onerror при инициализации, раньше этого файла, и снимает сообщение
       до дописки. Поэтому состояние отдаёт функция, а прикрепляет его
       beforeSend в sentry-init.js — в момент захвата, пока маркер области цел.
       Канал __aeDiagnostic остаётся, но на него надежды нет: за месяц из
       37 633 tool_diagnostic не доехало ни одного sb_foreach_undef. */
    function sbState() {
        return 'where=' + _sbWhere
            + ' nav=' + (typeof nav)
            + ' groups=' + (typeof groups)
            + ' sys=' + (typeof sysItems)
            + ' unl=' + (typeof unlistedTools) + '/' + (Array.isArray(unlistedTools) ? 'arr' : 'not')
            + ' st=' + (window.__searchThread ? (window.__searchThread.mode() || 'idle') + '/' + (window.__searchThread.ready() ? 'ready' : 'prep') : 'none')
            + ' eng=' + (typeof window.TimbricaSearch)
            + ' cfg=' + (cfg && typeof cfg === 'object' ? Object.keys(cfg).join(',') : typeof cfg);
    }
    window.__sbState = sbState;
    (function () {
        var told = false;
        window.addEventListener('error', function (ev) {
            var msg = (ev && ev.message) || '';
            if (told || msg.indexOf('forEach') === -1) return;
            told = true;   // одного отчёта на страницу достаточно
            var st = sbState();
            try { window.__aeDiagnostic && window.__aeDiagnostic({ issue: 'sb_foreach_undef', d: st }); } catch (_) {}
            try {
                if (ev && ev.error && typeof ev.error.message === 'string' && ev.error.message.indexOf('[sbw ') === -1) {
                    ev.error.message += ' [sbw ' + st + ']';
                }
            } catch (_) {}
        }, true);
    })();
    var sysItems=nav.querySelectorAll('.sb-item[data-system]');

    // ── Разделы рубрик (не аккордеон: оглавление — полоса иконок ниже) ──
    var activeGroup=cfg.activeGroup||null;
    var groups=nav.querySelectorAll('.sb-grp');

    var _scrolledToActive=false;
    /* Пункт, по которому нажали, встаёт на новой странице ТУДА ЖЕ, где был, —
       под курсор, а не в центр списка. Жалоба 23.10.2026 (tembrica, fr, 1920×911):
       человек прошёл ~20 тулов по одному в секунду, а список после каждого
       нажатия сам перецентровывался — стенд: нажал «Améliorateur audio» на
       высоте 196, на новой странице там «Accueil»; нажал на 816 — там чужой тул.
       Второе нажатие двойного щелчка (у пререндера переход мгновенный) уходило
       в соседний пункт. Центр — только для входа не из списка (поиск, ссылка).
       Высота — экранная: ровно её видит курсор. */
    var SB_KEEP='sb:keep';
    nav.addEventListener('click',function(e){
        if(e.defaultPrevented||e.button!==0||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;
        var a=e.target&&e.target.closest&&e.target.closest('a[href]');
        if(!a||!nav.contains(a)||a.target==='_blank'||a.origin!==location.origin)return;
        try{sessionStorage.setItem(SB_KEEP,JSON.stringify({p:a.pathname,y:Math.round(a.getBoundingClientRect().top),t:Date.now()}))}catch(_){}
    },true);
    function keptTop(){
        try{
            var k=JSON.parse(sessionStorage.getItem(SB_KEEP)||'null');
            if(!k)return null;
            sessionStorage.removeItem(SB_KEEP);
            return (k.p===location.pathname&&Date.now()-k.t<30000&&typeof k.y==='number')?k.y:null;
        }catch(_){return null}
    }
    /* ── Где человек: текущий пункт и его рубрика (docs/why/sidebar-where-you-are.md) ──
       Решает ТОЛЬКО эта страница: cfg.activeGroup (рубрика тула из конфига или
       хаба /tools/{slug}) и cfg.current (слаг тула); памяти о рубриках прошлых
       страниц нет. Текущими помечаются ВСЕ пункты этой страницы: тул по слагу
       (в рубрике, у тестера, где угодно) и системные ссылки по пути («Главная»,
       «Мой гараж» в меню аватара). Жалоба Фарида 30.10 (/ru/car-logbook):
       у вошедшего пункт тула скрыт (`account_home`), пометка и центрирование
       брали ПЕРВЫЙ найденный узел — скрытый, с нулевой рамкой, — и список
       оставался наверху, а «Авто» раскрывалась за краем: сайдбар «не участвовал». */
    var curSlug=cfg.current||null;
    if(!curSlug){var _sm=document.querySelector('meta[name="tool-slug"]');curSlug=(_sm&&_sm.content)||null}
    function cssq(v){return (window.CSS&&CSS.escape)?CSS.escape(v):String(v).replace(/["\\]/g,'\\$&')}
    function trimPath(p){return String(p||'').replace(/\/+$/,'')||'/'}
    function markOne(el){el.classList.add('active');el.setAttribute('aria-current','page')}
    function markCurrent(){
        if(curSlug)nav.querySelectorAll('.sb-item[data-slug="'+cssq(curSlug)+'"]').forEach(markOne);
        var here=trimPath(location.pathname);
        sb.querySelectorAll('a.sb-item[href]:not([data-slug])').forEach(function(a){
            try{if(a.origin===location.origin&&trimPath(a.pathname)===here)markOne(a)}catch(_){}
        });
    }
    function shown(el){try{return !!(el&&el.getClientRects().length)}catch(_){return false}}
    function activeGrp(){return activeGroup?nav.querySelector('.sb-grp[data-group="'+cssq(activeGroup)+'"]'):null}
    // Пункт, который показываем: видимый текущий в рубрике страницы, иначе любой видимый текущий.
    function currentItem(){
        var list=nav.querySelectorAll('.sb-item[aria-current="page"]'),best=null;
        for(var i=0;i<list.length;i++){
            var it=list[i];if(!shown(it))continue;
            var g=it.closest('.sb-grp');
            if(activeGroup&&g&&g.getAttribute('data-group')===activeGroup)return it;
            if(!best)best=it;
        }
        return best;
    }
    /* Показать, где человек, ВНУТРИ прокрутки списка (nav.scrollTop) — страница
       не двигается никогда. Уже видно (и пункт, и заголовок его рубрики) — не
       трогаем; иначе пункт ближе к центру, но заголовок рубрики не уходит за
       верхний край, если оба помещаются: рубрика и тул видны вместе. Без пункта
       (хаб) — заголовок рубрики к верху. Пункт, по которому нажали в списке
       прошлой страницы, встаёт под курсор (keptTop). Мгновенно, один раз. */
    function revealCurrent(){
        if(_scrolledToActive)return;
        // Свёрнутый сайдбар: панели нет — показывать нечего; сделаем, когда
        // её развернут (setMini).
        if(miniOn())return;
        var it=currentItem(),g=it?(it.closest('.sb-grp')||activeGrp()):activeGrp();
        if(!it&&!g)return;
        if(!nav.clientHeight)return;
        _scrolledToActive=true;
        // Cosmetic positioning only — must never throw. On one iOS 12 install a
        // third-party injection replaces Element.getBoundingClientRect with a
        // broken wrapper ("patchRect") that dies with "Illegal invocation"
        // through us (TIMBRICA-FRONTEND-CF). Unreadable layout → skip the nudge.
        try{
            var y=it?keptTop():null;
            if(y!==null){nav.scrollTop+=it.getBoundingClientRect().top-y}
            else{
                var nr=nav.getBoundingClientRect(),pad=8,top=nr.top+pad,bot=nr.top+nav.clientHeight-pad;
                var hd=g&&(g.querySelector('.sb-grp-toggle')||g),hr=hd&&shown(hd)?hd.getBoundingClientRect():null;
                var ir=it?it.getBoundingClientRect():null;
                var itOk=!ir||(ir.top>=top&&ir.bottom<=bot),hdOk=!hr||(hr.top>=top&&hr.bottom<=bot);
                var both=!!(ir&&hr&&ir.bottom-hr.top<=bot-top);
                if(!(itOk&&(hdOk||(ir&&!both)))){
                    var cur=nav.scrollTop,want;
                    var headAt=hr?cur+(hr.top-top):null;
                    if(ir){
                        want=cur+(ir.top-nr.top)-(nav.clientHeight-ir.height)/2;
                        if(both)want=Math.min(want,headAt);
                    }else want=headAt;
                    nav.scrollTop=Math.max(0,want);
                }
            }
        }catch(_e){}
        // Пререндер разложил список ДО нажатия; нажатие известно только к активации.
        if(it&&document.prerendering)document.addEventListener('prerenderingchange',function(){
            var y=keptTop();
            if(y!==null)try{nav.scrollTop+=it.getBoundingClientRect().top-y}catch(_e){}
        },{once:true});
    }
    // Рубрики — аккордеоном (Фарид 15.10.2026): раскрыта рубрика открытой
    // страницы — на загрузке сразу, без анимации раскрытия (раскладка готова к
    // показу пункта), один раз за страницу: свёрнутую человеком здесь же она
    // назад не раскрывает. Нажатие — делегированно: переживает ленивую вставку.
    function setOpen(g,open,instant){
        var body=instant&&g.querySelector('.sb-grp-body'),t=g.querySelector('.sb-grp-toggle');
        if(body){var pt=body.style.transition;body.style.transition='none';g.classList.toggle('open',open);void body.offsetHeight;body.style.transition=pt||''}
        else g.classList.toggle('open',open);
        if(t)t.setAttribute('aria-expanded',open?'true':'false');
    }
    var _openedActive=false;
    function initGroups(){
        _sbWhere = 'initGroups';
        groups=nav.querySelectorAll('.sb-grp');
        markCurrent();
        var g=_openedActive?null:activeGrp();
        if(g){_openedActive=true;if(!g.classList.contains('open'))setOpen(g,true,true)}
        revealCurrent();
    }
    nav.addEventListener('click',function(e){
        var t=e.target&&e.target.closest&&e.target.closest('.sb-grp-toggle');
        if(!t||!nav.contains(t))return;
        var g=t.closest('.sb-grp');if(!g)return;
        setOpen(g,!g.classList.contains('open'));
    });
    initGroups();
    // Re-init when sidebar is lazy-loaded
    window.addEventListener('sidebar-loaded',initGroups);

    // ── Bookmarks count badge in «Главное» ──
    // window.Bookmarks (timbrica-core.js) holds the localStorage-backed list.
    // It may not be ready when this defer-script runs, so retry once.
    function fillBookmarkCount(){
        try{
            var el=document.getElementById('sbBmCount');
            if(!el||!window.Bookmarks||typeof window.Bookmarks.get!=='function')return false;
            var n=(window.Bookmarks.get()||[]).length;
            if(n>0){el.textContent=n>99?'99+':String(n);el.hidden=false;}
            else{el.hidden=true;}
            return true;
        }catch(e){return false;}
    }
    if(!fillBookmarkCount())setTimeout(fillBookmarkCount,500);
    // Live-update the badge when bookmarks change (same tab via 'bookmarks-changed'
    // from timbrica-core Bookmarks.toggle; other tabs via the storage event).
    document.addEventListener('bookmarks-changed',fillBookmarkCount);
    window.addEventListener('storage',function(e){if(e.key==='timbrica_bookmarks')fillBookmarkCount();});

    var sbNR=document.getElementById('sbNoResults');
    var sbSuggest=document.getElementById('sbSuggest');

    function sbBigram(a,b){
        a=a.toLowerCase();b=b.toLowerCase();
        if(a===b)return 1;if(a.length<2||b.length<2)return 0;
        var bg=new Map(),i,s;
        for(i=0;i<a.length-1;i++){s=a.substr(i,2);bg.set(s,(bg.get(s)||0)+1)}
        var m=0;
        for(i=0;i<b.length-1;i++){s=b.substr(i,2);var c=bg.get(s);if(c>0){bg.set(s,c-1);m++}}
        return(2*m)/(a.length+b.length-2);
    }
    function sbFuzzyFind(q){
        _sbWhere = 'fuzzyFind';
        var items=nav.querySelectorAll('.sb-item'),scored=[];
        items.forEach(function(it){
            var n=kwOf(it);
            var s=sbBigram(q,n);
            if(s>0.15){var ico=it.querySelector('.sb-icon')||it.querySelector('.sb-sys-icon');var lbl=it.querySelector('.sb-item-label');var nm=lbl?lbl.textContent.trim():it.textContent.trim();if(!lbl&&ico)nm=nm.replace(ico.textContent,'').trim();scored.push({el:it,name:nm,href:it.getAttribute('href'),icon:ico,s:s})}
        });
        scored.sort(function(a,b){return b.s-a.s});
        return scored.slice(0,3);
    }

    function clearUnlisted(){
        nav.querySelectorAll('.sb-unlisted').forEach(function(el){el.remove()});
    }

    // «Нет такого инструмента? Опишите — сделаем». Нужен в ОБОИХ ветках поиска:
    // ранжированной и запасной (она работает, пока индекс ещё летит), иначе
    // предложение появляется через раз — в зависимости от того, успел ли
    // доехать /api/search-data. Гейт фразы — общий, в движке.
    function requestToolHtml(){
        if(!si||!si.dataset.sRq||!si.dataset.sRqUrl)return '';
        var raw=si.value.trim();
        var E=window.TimbricaSearch;
        if(!E||!E.requestable||!E.requestable(raw))return '';
        return '<a href="'+si.dataset.sRqUrl+'?q='+encodeURIComponent(raw)+'" class="sb-item sb-request-tool" data-sc="request-tool">'
            +'<span class="sb-icon">💡</span><span class="sb-item-label">'+si.dataset.sRq+'</span></a>';
    }

    /**
     * Человек стоит НА странице инструмента и ничего не нашёл.
     *
     * Замер `search_miss` за 30 дней (14.08): 138 из 168 сайдбарных промахов
     * набраны именно так, и это ввод ДЛЯ ОТКРЫТОГО инструмента, а не запрос в
     * каталог: «якутск» на карте засветки, «кадышева» в караоке, «ic 741» в
     * симуляторе схем, номер рейса на трекере. Причём НЕ после неудачи в самом
     * туле: из 51 сессии на /flight-tracker 37 печатали в сайдбар РАНЬШЕ, чем
     * трогали поле тула, ещё 7 не трогали его вовсе. То есть сайдбар просто
     * первое поле, которое видно (на телефоне поле трекера — 1.4 экрана ниже).
     *
     * Предлагать таким людям «опишите инструмент — сделаем» бессмысленно: они
     * уже внутри нужного инструмента. Объясняем, что это за строка, и даём
     * перейти к настоящему полю.
     */
    function insideToolHtml(){
        if(!si||!si.dataset.sIt)return '';
        if(!document.querySelector('meta[name="tool-slug"]'))return '';
        var field=toolOwnField();
        var h='<div class="sb-inside-tool">'+si.dataset.sIt+'</div>';
        if(field&&si.dataset.sItGo){
            h+='<button type="button" class="sb-item sb-inside-go" data-sc="inside-tool">'
                +'<span class="sb-icon">⬆️</span><span class="sb-item-label">'+si.dataset.sItGo+'</span></button>';
        }
        return h;
    }

    /**
     * Собственное поле инструмента — первое видимое текстовое поле ВНЕ шапки,
     * сайдбара и подвала. Эвристика намеренно осторожная: не нашли — просто не
     * показываем кнопку, а объяснение остаётся. Уводить человека в случайное
     * поле хуже, чем не уводить никуда.
     */
    function toolOwnField(){
        var all=document.querySelectorAll('main input, main textarea, .tool-container input, .tool-container textarea');
        for(var i=0;i<all.length;i++){
            var el=all[i];
            if(el===si||el.id==='siteSearch')continue;
            if(el.closest('header,nav,.sidebar,footer,.sb-search,.search-box'))continue;
            var t=(el.getAttribute('type')||'text').toLowerCase();
            if(el.tagName==='INPUT'&&['text','search','number','tel','url','email'].indexOf(t)<0)continue;
            var r=el.getBoundingClientRect();
            if(r.width<40||r.height<10)continue;
            if(getComputedStyle(el).visibility==='hidden')continue;
            return el;
        }
        return null;
    }

    // ── Ranked mode ──
    // Renders engine results (already sorted by relevance) into #sbSearchResults
    // and hides the grouped nav wholesale. The legacy filter below stays as the
    // degraded path while the index is still in flight or failed to load.
    var _missTimer=null;
    // The question goes to the search thread; the answer is drawn only if the
    // box still holds the same string — a later key has already asked again.
    // Rescue (data-like strings, wrong layout, glued words) is computed there
    // too: it needs the prepared index, which lives only in the thread.
    function rankedSearch(q,words){
        _sbWhere = 'rankedSearch';
        window.__searchThread.search(q,{limit:24,rescue:q.length>=3},function(r){
            if(!si||si.value.toLowerCase().trim()!==q)return;
            _sbWhere = 'rankedRender';
            clearUnlisted();
            setSearching(false);
            rankedRender(q,words,r.res,r.fb);
        },'sb');
    }
    // Меню под выдачей прячется классом с content-visibility:hidden (critical.css,
    // .sb-nav.sb-off), а не display:none: display выбрасывал из раскладки все
    // 58 рубрик с кнопками и SVG и строил их заново при возврате — 25–55 мс на
    // показ выдачи и 63–152 мс на возврат меню при ×4; так — 1–17 и 3–48
    // (замер 23.10.2026). Раскладка меню сохраняется, а не разрушается.
    function hideMenu(on){nav.classList.toggle('sb-off',!!on);}
    // Пока поток готовит индекс: пункты меню, в названии которых есть строка,
    // плоским списком в блоке выдачи. Меню не раскрывается и не фильтруется
    // (это раскладка всех ~940 пунктов), «не найдено» не рисуется — ответ
    // потока придёт следом и заменит список.
    function interimRender(q,words){
        _sbWhere = 'interim';
        var items=nav.querySelectorAll('.sb-item:not(.sb-unlisted):not([data-system])');
        var h='',n=0;
        for(var i=0;i<items.length&&n<20;i++){
            var t=kwOf(items[i]);
            var hit=words.length>1?words.some(function(w){return t.indexOf(w)>=0}):t.indexOf(q)>=0;
            if(hit){h+=items[i].outerHTML;n++;}
        }
        clearUnlisted();
        srBox.innerHTML=h;
        srBox.style.display='';
        hideMenu(true);
        if(sbNR)sbNR.style.display='none';
        setSearching(true);
    }
    function rankedRender(q,words,res,rescued){
        var E=window.TimbricaSearch||{};
        var shown=res.slice(0,20);
        var h='';
        // Движок отдаёт похожие по написанию только когда точных нет — тогда
        // это не «результаты», а «возможно, вы имели в виду» (как в хедере).
        if(shown.length&&shown.every(function(x){return x.fuzzy})&&si.dataset.sDy){
            h+='<div class="sb-suggest-label">'+si.dataset.sDy+'</div>';
        }
        shown.forEach(function(x){
            h+='<a href="'+x.t.url+'" class="sb-item" data-sc="'+String(x.t.name).replace(/"/g,'&quot;')+'"><span class="sb-icon">'+(x.t.icon||'')+'</span><span class="sb-item-label">'+x.t.name+'</span></a>';
        });
        // Скрытые тулы в публичном индексе не живут — их, как и раньше,
        // добираем подстрокой по имени+kw и подклеиваем хвостом.
        var extra=0;
        unlistedTools.forEach(function(ut){
            var match=words.length>1
                ?words.some(function(w){return ut.name.indexOf(w)>=0})
                :ut.name.indexOf(q)>=0;
            if(match){
                h+='<a href="'+ut.href+'" class="sb-item sb-unlisted"><span class="sb-icon">'+ut.icon+'</span><span class="sb-item-label">'+ut.title+'</span></a>';
                extra++;
            }
        });
        srBox.innerHTML=h;
        srBox.style.display='';
        hideMenu(true);
        if(sbNR)sbNR.style.display='none';
        bindPrefetch(srBox);
        clearTimeout(_missTimer); if(window.__aeDeferredCancel)window.__aeDeferredCancel('search_miss');
        // Спасать нужно не только ПУСТУЮ выдачу: список из одних похожих по
        // написанию (все с покрытием 0) — тоже промах, просто выглядит как
        // находка. Гейт — E.weak(), как в хедере и на /search; скрытые тулы,
        // добранные подстрокой (`extra`), спасение отменяют — они настоящие.
        var _weak=(E.weak?E.weak(res):shown.length===0)&&extra===0;
        if(_weak&&q.length>=3){
            // Строка может быть данными (номер рейса, IP), набранной в чужой
            // раскладке или слипшимися словами. Отрисовка здесь своя (сайдбар
            // — плоский список ссылок), но РАЗБОР общий, иначе три поверхности
            // разъедутся.
            var fb=rescued||null;
            if(fb&&fb.type==='route'){
                srBox.innerHTML='<a href="'+fb.url+'" class="sb-item sb-route">'
                    +'<span class="sb-icon">'+(fb.tool.icon||'')+'</span>'
                    +'<span class="sb-item-label">'+fb.tool.name+' · '+fb.value+'</span></a>';
                bindPrefetch(srBox);
            } else if(fb&&(fb.type==='layout'||fb.type==='split'||fb.type==='term')){
                var lh='';
                if(si.dataset.sDy&&fb.query)lh+='<div class="sb-suggest-label">'+si.dataset.sDy+' '+fb.query+'</div>';
                fb.results.slice(0,20).forEach(function(x){
                    lh+='<a href="'+x.t.url+'" class="sb-item" data-sc="'+String(x.t.name).replace(/"/g,'&quot;')+'"><span class="sb-icon">'+(x.t.icon||'')+'</span><span class="sb-item-label">'+x.t.name+'</span></a>';
                });
                srBox.innerHTML=lh;
                bindPrefetch(srBox);
            } else if(shown.length===0){
                // Спасать нечем И показывать нечего. (Похожие по написанию,
                // если они есть, остаются на экране под своей подписью — это
                // лучше, чем стереть их ради надписи «не найдено».)
                // Раньше здесь не рисовалось РОВНО НИЧЕГО:
                // ранжированный поиск прятал навигацию и оставлял пустую
                // колонку без единого слова — «сайдбар сломался», а не «не
                // нашлось». Пишем это словами и предлагаем заказать инструмент
                // (гейт фразы — в движке, чтобы обломок «su67» такого
                // предложения не получал).
                var _it=insideToolHtml();
                srBox.innerHTML='<div class="sb-no-hit">'+(si.dataset.sNm||'')+'</div>'+(_it||requestToolHtml());
            }
            // Промах — та же телеметрия, что и у хедер-поиска: топ search_miss
            // = готовый список тулов, которым не хватает ключевых слов. `r` —
            // чем спасли, если спасли. `search_query` отсюда НЕ шлём: сайдбар
            // фильтрует навигацию посимвольно, и непустых запросов тут на
            // порядок больше — это ровно тот high-frequency шум, который в
            // AnalyticsEvent::ALLOWED_TYPES отсекали намеренно.
            var _mr=fb?(fb.type==='route'?fb.kind:fb.type):'';
            /* Через общий примитив, а не свой setTimeout: успешное спасение
               показывает карточку мгновенно, человек кликает и уходит — свой
               таймер умирает вместе со вкладкой, и УСПЕХ не отправляется
               никогда, а провал отправляется всегда. Замер 25.08 — см. шапку
               `__aeDeferred` в telemetry-tier0.js. */
            if(window.__aeDeferred)window.__aeDeferred('search_miss','search_miss',
                {q:q.slice(0,60),loc:loc,src:'sb',r:_mr},1200);
        } else if(shown.length+extra===0){
            // Строка короче трёх символов: спасать и считать нечего, но пустая
            // колонка выглядит одинаково сломанной при любой длине запроса.
            srBox.innerHTML='<div class="sb-no-hit">'+(si.dataset.sNm||'')+'</div>';
        }
    }
    function exitRanked(){
        clearTimeout(_missTimer); if(window.__aeDeferredCancel)window.__aeDeferredCancel('search_miss');
        if(srBox){srBox.style.display='none';srBox.innerHTML='';}
        hideMenu(false);
    }
    /**
     * «Показать поле инструмента» — увести человека из поиска по каталогу в то
     * поле, которое он и искал. На телефоне поле тула бывает в полутора экранах
     * ниже (замер на /flight-tracker: строка сайдбара y=52, поле тула y=1216),
     * поэтому одного фокуса мало.
     *
     * scrollIntoView строго block:'nearest' — сдвинет страницу, только если
     * поле реально за экраном, и никогда не прыгнет к началу (глобальное
     * правило «никакой автопрокрутки»). Фокус — с preventScroll, иначе браузер
     * сам сделает свой прыжок до нашего.
     */
    function jumpToToolField(){
        var el=toolOwnField();
        if(!el)return;
        closeSidebar();
        try{el.focus({preventScroll:true})}catch(_){el.focus()}
        try{el.scrollIntoView({block:'nearest'})}catch(_){}
    }
    document.addEventListener('click',function(e){
        var b=e.target.closest&&e.target.closest('.sb-inside-go');
        if(!b)return;
        e.preventDefault();
        /* Событие search_click шлёт общий обработчик ниже (кнопка несёт класс
           .sb-item и data-sc), второй раз считать не надо. */
        jumpToToolField();
    });
    if(srBox)srBox.addEventListener('click',function(e){
        var a=e.target.closest('.sb-item');
        if(a&&window.__ae){
            try{window.__ae('search_click',{q:si?si.value.trim():'',clicked:a.dataset.sc||'',url:a.getAttribute('href')||'',src:'sb'})}catch(_){}
        }
    });
    // Тот же счёт для запасной ветки: она рисует в #sbNoResults, а не в srBox,
    // и без этого переход «пустая выдача → заявка» терялся бы ровно в тех
    // случаях, когда индекс не успел доехать.
    if(sbNR)sbNR.addEventListener('click',function(e){
        var a=e.target.closest('.sb-item');
        if(a&&window.__ae){
            try{window.__ae('search_click',{q:si?si.value.trim():'',clicked:a.dataset.sc||'',url:a.getAttribute('href')||'',src:'sb'})}catch(_){}
        }
    });

    var _sbTimer;
    if(si)si.addEventListener('input',function(){
        clearTimeout(_sbTimer);
        var el=this;
        _sbTimer=setTimeout(function(){
            /* Sentry FH: «Cannot read properties of undefined (reading 'forEach')»,
             * 3 события / 3 человека, Chrome 142, три разные страницы.
             *
             * Виновника по стеку назвать НЕЛЬЗЯ: sourcemap отображает
             * приблизительно — у двух событий одного релиза кадр указывает на
             * `groups.forEach`, у третьего на `nav.querySelectorAll(…).forEach`,
             * а обе величины по построению NodeList и undefined быть не могут.
             * Замерено в браузере: такой текст даёт ТОЛЬКО обращение к
             * undefined (у null сообщение другое — «reading 'querySelectorAll'»),
             * значит получатель существует лишь на бумаге.
             *
             * Рассыпать `|| []` по вызовам — спрятать причину и оставить её
             * жить. Поэтому здесь ДИАГНОСТИКА, а не заглушка: снимаем типы всех
             * кандидатов в момент отказа и пробрасываем ошибку дальше
             * НЕТРОНУТОЙ. Следующее событие назовёт виновника само. Тот же
             * приём, что ard_invalid_state у /ar-drawing. */
            try {
                _sbWhere = 'filter';
                var q=el.value.toLowerCase().trim();
                var visibleTools=0;
                var words=q.split(/\s+/).filter(function(w){return w.length>0});

                // Вопрос — в поток поиска. Готов индекс — ответ придёт за
                // миллисекунды, и временная выдача по названиям не нужна: её
                // режим (`sb-searching`) раскладывает все ~940 пунктов меню,
                // на слабом ноутбуке — сотни миллисекунд отрисовки впустую.
                var T=window.__searchThread;
                if(q.length>0&&srBox&&T&&window.TimbricaSearch){
                    rankedSearch(q,words);                 // поднимает поток, если он ещё спал
                    if(T.ready())return;
                    // Индекс ещё готовится (первые 1–2 с на слабом ноутбуке —
                    // ровно когда человек начинает печатать): названия с этой
                    // строкой плоским списком и «Ищем…», а не раскрытие всех
                    // рубрик меню — та раскладка стоит ~180 мс на каждое
                    // нажатие при ×4 (замер 23.10.2026). Ответ потока заменит список.
                    if(T.waiting()){interimRender(q,words);return;}
                }

                // Сюда — только когда ранжированной выдачи нет и не будет
                // (движок не загрузился, индекс не доехал): фильтр меню по названиям.
                // Toggle search mode on nav (expands all groups, hides toggles)
                nav.classList.toggle('sb-searching',q.length>0);
                exitRanked();
                var waiting=false;
                setSearching(false);

                nav.querySelectorAll('.sb-item:not(.sb-unlisted):not([data-system])').forEach(function(it){
                    var n=kwOf(it);
                    var show;
                    if(q.length===0){
                        show=true;
                    } else if(words.length>1){
                        show=words.some(function(w){return n.indexOf(w)>=0});
                    } else {
                        show=n.indexOf(q)>=0;
                    }
                    it.style.display=show?'':'none';
                    if(show)visibleTools++;
                });

                // Hide/show groups based on visible children
                if(q.length>0){
                    groups.forEach(function(g){
                        var hasVisible=g.querySelector('.sb-item:not([style*="display: none"]):not([style*="display:none"])');
                        g.style.display=hasVisible?'':'none';
                    });
                } else {
                    groups.forEach(function(g){g.style.display=''});
                }

                sysItems.forEach(function(it){it.style.display=q.length>0?'none':'';});
                clearUnlisted();
                if(q.length>0){
                    unlistedTools.forEach(function(ut){
                        var match=words.length>1
                            ?words.some(function(w){return ut.name.indexOf(w)>=0})
                            :ut.name.indexOf(q)>=0;
                        if(match){
                            var a=document.createElement('a');
                            a.href=ut.href;a.className='sb-item sb-unlisted';
                            a.innerHTML='<span class="sb-icon">'+ut.icon+'</span>'+ut.title;
                            nav.appendChild(a);
                            visibleTools++;
                        }
                    });
                }
                if(q.length>0){
                    nav.classList.add('expanded');
                    nav.classList.toggle('sb-empty',visibleTools===0);
                    if(visibleTools===0&&sbNR&&!waiting){
                        var fuzzy=sbFuzzyFind(q);
                        var h='';
                        if(fuzzy.length>0){
                            h='<div class="sb-suggest-label">'+(si.dataset.sDy||'')+'</div>';
                            fuzzy.forEach(function(f){
                                var ic=f.icon?f.icon.outerHTML:'';
                                h+='<a href="'+f.href+'" class="sb-item">'+ic+'<span class="sb-item-label">'+f.name+'</span></a>';
                            });
                        } else {
                            // Без похожих этот блок показывался ПУСТЫМ — рамка без
                            // единого слова. Пишем «не найдено» словами.
                            h='<div class="sb-no-hit">'+(si.dataset.sNm||'')+'</div>';
                        }
                        sbSuggest.innerHTML=h+(insideToolHtml()||requestToolHtml());
                        sbNR.style.display='';
                    } else if(sbNR){
                        sbNR.style.display='none';
                    }
                } else {
                    clearUnlisted();
                    nav.classList.remove('expanded');
                    nav.classList.remove('sb-empty');
                    if(sbNR)sbNR.style.display='none';
                }
            } catch (_sbErr) {
                /* ⚠️ Диагностика едет В САМОЙ ОШИБКЕ, а не только в телеметрию.
                 *
                 * Прошлая версия писала только `__aeDiagnostic`, и это оказалось
                 * невидимо ровно для нужной публики: `window.__ae` — это NO-OP,
                 * пока не дано согласие на аналитику (и при DNT), а проверка
                 * `typeof __aeDiagnostic === 'function'` при этом ПРОХОДИТ.
                 * Ошибки таких людей Sentry получает, а их диагностику — нет.
                 * Замерено: FH пришла из релиза, где диагностика уже стояла, и
                 * в канале tool_diagnostic не появилось ни строки при 974
                 * диагностиках за сутки от остальных.
                 *
                 * Поэтому типы кандидатов дописываются в СООБЩЕНИЕ ошибки: она
                 * и так доезжает до Sentry тем же путём, что довёз саму FH.
                 * Это только имена типов — ничего личного в них нет. */
                var _sbState = 'nav=' + (typeof nav)
                    + ' groups=' + (typeof groups)
                    + ' sys=' + (typeof sysItems)
                    + ' unl=' + (typeof unlistedTools) + '/' + (Array.isArray(unlistedTools) ? 'arr' : 'not')
                    + ' st=' + (window.__searchThread ? (window.__searchThread.mode() || 'idle') : 'none')
                    + ' srBox=' + (typeof srBox)
                    + ' eng=' + (typeof window.TimbricaSearch);
                try {
                    window.__aeDiagnostic && window.__aeDiagnostic({ issue: 'sb_filter_undef', d: _sbState });
                } catch (_) {}
                try {
                    if (_sbErr && typeof _sbErr.message === 'string') {
                        _sbErr.message += ' [sb ' + _sbState + ']';
                    }
                } catch (_) {}
                throw _sbErr;   // ничего не прячем: ошибка летит как летела
            }
        },150);
    });
    // Navigate to search page on Enter or magnifying glass click
    function goSearch(){
        var q=si?si.value.trim():'';
        window.location.href='/'+loc+'/search'+(q.length>=2?'?q='+encodeURIComponent(q):'');
    }
    if(si)si.addEventListener('keydown',function(e){if(e.key==='Enter')goSearch()});
    // Focus-loss diagnostic: if the search input gains focus and loses it
    // within 250 ms WITHOUT the user typing anything, that's the symptom
    // of the body-scroll-lock interaction described below (holdPage). Emit
    // telemetry so we can validate the lock changes (28.05 position:fixed,
    // 18.10 no freeze at all) on Yandex Browser Mobile + similar cohorts.
    if(si){
        var _focusAt=0,_typed=false;
        si.addEventListener('input',function(){_typed=true});
        si.addEventListener('focus',function(){_focusAt=Date.now();_typed=false});
        si.addEventListener('blur',function(){
            if(!_focusAt)return;
            var ms=Date.now()-_focusAt;
            if(ms<250&&!_typed&&window.__ae){
                try{window.__ae('feature_use',{
                    slug:'__site',f:'sb_search_focus_lost_quick',
                    ms:ms,
                    sb_open:sb.classList.contains('open')?1:0,
                    body_locked:document.body.dataset.sbLocked==='1'?1:0,
                    coarse:(window.matchMedia&&window.matchMedia('(pointer:coarse)').matches)?1:0
                })}catch(_){}
            }
            _focusAt=0;
        });
    }
    var sbGo=document.getElementById('sbSearchGo');
    if(sbGo)sbGo.addEventListener('click',goSearch);
    var sc=document.getElementById('sbClose');
    // Страница под открытой шторкой НЕ замораживается (18.10.2026).
    // Было (28.05–18.10): тело position:fixed; top:-y, на закрытии — scrollTo(0,y)
    // (до того — overflow:hidden, который на Android ронял фокус поиска: Олег,
    // YaBrowser, 28.05). Заморозка делала документ коротким, и iOS на это
    // отвечал так, что ни шторка, ни затемнение не могли закрыть низ:
    // - Chrome iOS сжимал область страницы до размера с панелями, а сами панели
    //   оставались свёрнутыми — под меню «пустота», куда страница рисовать не
    //   может (Фарид 18.10, скриншот; «подол» шторки там тоже не виден);
    // - visualViewport первые 30–80 мс отдавал старую прокрутку (телеметрия
    //   sb_drawer_below_layer: vt = 1 161 … 17 940 у chr-ios и safari);
    // - на закрытии прыжок к началу и обратно и пересборка панелей — «что-то
    //   прокручивается, когда закрываю меню».
    // Прокрутку под шторкой с 12.10 и так держит holdDrawer: протяжку, которую
    // некому принять, он гасит на первом touchmove, колесо — так же. Поэтому
    // документ теперь не меняется вовсе; позиция возвращается, только если её
    // всё же сдвинул сам браузер (клавиатура у поиска), — мгновенно, без
    // плавной прокрутки. Флаги sbLocked/sbScrollY остаются: их читает
    // диагностика фокуса поиска выше.
    // document.body CAN be null when a MediaQueryList 'change' fires during
    // a partial page lifecycle — Yandex Browser content scripts and some
    // privacy extensions briefly null out body during DOM rewrites, and
    // the MQL handler is bound for the whole window lifetime so it can
    // outlive the body it was registered against (TIMBRICA-FRONTEND-8Z).
    // Guard at both hold/release boundaries so a stale listener fire becomes
    // a silent no-op instead of a crash.
    function holdPage(){
        var b=document.body; if(!b)return;
        if(b.dataset.sbLocked==='1')return;
        b.dataset.sbScrollY=String(window.scrollY||window.pageYOffset||0);
        b.dataset.sbLocked='1';
    }
    function releasePage(){
        var b=document.body; if(!b)return;
        if(b.dataset.sbLocked!=='1')return;
        var y=parseInt(b.dataset.sbScrollY||'0',10),now=window.scrollY||window.pageYOffset||0;
        delete b.dataset.sbLocked;
        delete b.dataset.sbScrollY;
        if(Math.abs(now-y)<=1)return;
        var r=document.documentElement,was=r.style.scrollBehavior;
        r.style.scrollBehavior='auto';
        window.scrollTo(0,y);
        r.style.scrollBehavior=was;
    }

    /* ── Протяжка при открытой шторке не доходит до корня документа ──
     *
     * Жалоба Фарида 12.10.2026 (iPhone, Chrome iOS): шторка открывается
     * ровно, но после свайпа вверх ВСЁ фиксированное — шторка, затемнение,
     * шапка — уезжает вверх на высоту панели браузера (~55 px): переключатель
     * «Инструменты / Специалисты» прячется под край, внизу открывается
     * пустая полоса, список больше не листается. Лечит только F5.
     *
     * Механизм. Тело заморожено (position:fixed выше), но корень документа
     * на iOS всё равно принимает протяжку: панели браузера дают ему ход на
     * свою высоту, даже когда прокручивать нечего. Корень едет, слой
     * фиксированных элементов — вместе с ним, а назад его не возвращает
     * никто. Протяжке достаточно начаться там, где нет своего скроллера:
     * переключатель разделов, поиск, ряд кнопок внизу, затемнение справа —
     * или упереться в край списка (iOS до 16 не знает overscroll-behavior).
     * На Android та же протяжка вниз по затемнению — это pull-to-refresh,
     * то есть перезагрузка страницы под открытым меню.
     *
     * Правило: пока шторка открыта, протяжку получает только элемент,
     * который сам может прокрутиться в эту сторону (список рубрик, выдача
     * поиска, лента чата поверх). Остальное гасится на ПЕРВОМ touchmove —
     * WebKit решает судьбу нативной прокрутки по нему, позже отказ уже не
     * слушают. Щипок двумя пальцами не трогаем: масштаб — право читателя. */
    var _tg=null;
    function _tgScroller(el,vertical){
        for(;el&&el.nodeType===1&&el!==document.body&&el!==document.documentElement;el=el.parentElement){
            var o=getComputedStyle(el)[vertical?'overflowY':'overflowX'];
            if((o==='auto'||o==='scroll')&&(vertical?el.scrollHeight>el.clientHeight+1:el.scrollWidth>el.clientWidth+1))return el;
        }
        return null;
    }
    function _tgStart(e){
        var t=e.touches&&e.touches[0];
        _tg=t?{x:t.clientX,y:t.clientY,v:_tgScroller(e.target,true),h:_tgScroller(e.target,false)}:null;
    }
    function _tgMove(e){
        if(!_tg||!e.cancelable||!e.touches||e.touches.length!==1)return;
        var t=e.touches[0],dx=t.clientX-_tg.x,dy=t.clientY-_tg.y,v=_tg.v;
        _tg.x=t.clientX;_tg.y=t.clientY;
        var across=Math.abs(dx)>Math.abs(dy);
        if(!v){
            if(across&&_tg.h)return;
            e.preventDefault();
            return;
        }
        if(across||!dy)return;
        if(dy>0?v.scrollTop<=0:v.scrollTop+v.clientHeight>=v.scrollHeight-1)e.preventDefault();
    }
    /* Колесо (узкое окно на компьютере, мышь у планшета) — то же правило: страница
     * под шторкой не заморожена, и колесо, которое некому принять, гасится. */
    function _tgWheel(e){
        if(e.ctrlKey||!e.cancelable||!e.deltaY)return;
        var v=_tgScroller(e.target,true);
        if(!v||(e.deltaY<0?v.scrollTop<=0:v.scrollTop+v.clientHeight>=v.scrollHeight-1))e.preventDefault();
    }

    /* Шторка держится видимой области, а не макета. Экранная клавиатура
     * (поиск в шторке) сжимает visualViewport, но не макет — низ шторки с
     * языком и профилем уходил под клавиатуру, и раньше до него дотягивались
     * протяжкой корня, которую теперь гасит правило выше. И если iOS всё же
     * сдвинет видимую область (фокус в поле, анимация панелей), шторка и
     * затемнение едут за ней, а не остаются висеть сдвинутыми. Тот же приём,
     * что у листа чата поддержки (SupportChat.openSheet). Пока ничего не
     * сдвинуто, инлайн-стилей нет: геометрию ведёт CSS. При щипке (scale ≠ 1)
     * не вмешиваемся. */
    function _fitClear(){
        [sb,ov].forEach(function(el){if(el){el.style.top='';el.style.bottom='';el.style.height=''}});
    }
    /* Видимая область бывает и НИЖЕ слоя fixed (жалоба Фарида 18.10, iPhone, Chrome iOS:
     * «адресная строка пропадает — внизу у меню пустота»): панели браузера свернулись,
     * а слой остался по прежней высоте, и под шторкой с затемнением видна страница.
     * Низ слоя меряем по самому затемнению (top:0;bottom:0) и дотягиваем шторку и
     * затемнение до низа видимой области, сохраняя отступ над баннером согласия.
     * Там, где браузер этого не сообщает, дыру закрывает «подол» шторки в critical.css.
     * Случай пишется в телеметрию (один раз на открытие): на Windows его не воспроизвести. */
    var _fitNoted=false,_openAt=0;
    function _fitNote(vt,vh,cb,under){
        if(_fitNoted||under<2||!window.__ae)return;
        _fitNoted=true;
        try{window.__ae('feature_use',{slug:'__site',f:'sb_drawer_below_layer',
            under:Math.round(under),vt:Math.round(vt),vh:Math.round(vh),cb:Math.round(cb),
            ih:window.innerHeight,ch:document.documentElement.clientHeight,ms:Date.now()-_openAt})}catch(_){}
    }
    function _fitVisible(){
        var vv=window.visualViewport;
        _fitClear();
        if(!vv||!sb.classList.contains('open')||Math.abs(vv.scale-1)>0.01)return;
        var top0=parseFloat(getComputedStyle(sb).top)||0,bottom0=top0+sb.offsetHeight;
        var cb=ov&&ov.classList.contains('active')?ov.getBoundingClientRect().bottom:0;
        var vt=vv.offsetTop,vb=vt+vv.height,under=cb?vb-cb:0;
        if(Math.abs(vt)<0.5&&vb>=bottom0-0.5&&under<0.5)return;
        _fitNote(vt,vv.height,cb,under);
        var top=top0+vt,bottom=under>=0.5?bottom0+under:Math.min(vb,bottom0+vt);
        sb.style.top=top+'px';sb.style.bottom='auto';sb.style.height=Math.max(0,bottom-top)+'px';
        if(ov){ov.style.top=vt+'px';ov.style.bottom='auto';ov.style.height=vv.height+'px'}
    }
    var _drawerHeld=false;
    function holdDrawer(on){
        if(on===_drawerHeld)return;
        _drawerHeld=on;
        var add=on?'addEventListener':'removeEventListener',vv=window.visualViewport;
        document[add]('touchstart',_tgStart,{capture:true,passive:true});
        document[add]('touchmove',_tgMove,{capture:true,passive:false});
        document[add]('wheel',_tgWheel,{capture:true,passive:false});
        if(vv){vv[add]('resize',_fitVisible);vv[add]('scroll',_fitVisible)}
        if(on){_fitNoted=false;_openAt=Date.now();_fitVisible()}else{_tg=null;_fitClear()}
    }

    function closeSidebar(){
        sb.classList.remove('open');ov.classList.remove('active');
        holdDrawer(false);
        releasePage();
    }
    /* ✕ шторки встаёт точно на место бургера: шапка после прокрутки сжата
     * (timbrica-core.js, hdr-compact), и бургер в ней на 12 px выше, чем в полной. */
    function _closeOverBurger(){
        if(!sc)return;
        sc.style.top='';
        var b=bg.getBoundingClientRect();
        if(b.height)sc.style.top=Math.round(b.top-sb.getBoundingClientRect().top)+'px';
    }
    if(bg)bg.addEventListener('click',function(){
        var isOpen=sb.classList.toggle('open');
        ov.classList.toggle('active',isOpen);
        if(isOpen)_closeOverBurger();
        if(isOpen){holdPage();holdDrawer(true)}
        else{holdDrawer(false);releasePage()}
    });
    if(ov)ov.addEventListener('click',closeSidebar);
    if(sc)sc.addEventListener('click',closeSidebar);
    /* Пункт ТЕКУЩЕЙ страницы ничего не перезагружает.
     *
     * Чат 698 (19.10.2026, /video-merge): человек полдня собирал склейку, повёл
     * мышью по рубрике «Видео» и нажал «Склейка видео» — пункт той самой
     * страницы. Ссылка вела на себя же, а правило пререндера `moderate` по
     * наведению уже подготовило свежую копию: нажатие мгновенно подменило
     * страницу пустой — «страница вылетела и всё пропало». Так теряет работу
     * любой тул, у которого она живёт в памяти вкладки, на ПК и в шторке.
     * Поэтому: обычное нажатие на ссылку этой же страницы только убирает
     * шторку (и раскрытие свёрнутого сайдбара); Ctrl/Shift/средняя кнопка —
     * браузеру, как раньше (новая вкладка). Обновить страницу — F5. Событие
     * `sb_self_click` — сколько таких нажатий и было ли что терять (заслон
     * «уйти?» вооружён / в зоне лежит файл). */
    sb.addEventListener('click',function(e){
        if(e.defaultPrevented||e.button!==0||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;
        var a=e.target&&e.target.closest&&e.target.closest('a[href]');
        if(!a||!sb.contains(a)||a.target==='_blank'||a.hasAttribute('download'))return;
        // Только путь: хвост адреса (?ysclid=… от Яндекса, ?nocache=1) — та же страница.
        if(a.origin!==location.origin||a.pathname!==location.pathname)return;
        e.preventDefault();
        try{if(window.__ae)window.__ae('feature_use',{slug:'__site',f:'sb_self_click',
            page:location.pathname.slice(0,80),
            armed:(window.__unsavedWork&&window.__unsavedWork.isArmed())?1:0,
            file:document.querySelector('.tu-collapsed')?1:0,
            drawer:sb.classList.contains('open')?1:0});}catch(_){}
        if(sb.classList.contains('open'))closeSidebar();
        try{if(document.documentElement.classList.contains('sb-peek')&&typeof closePeek==='function')closePeek(false);}catch(_){}
    });
    // Close mobile sidebar + overlay when resized to desktop.
    // iOS 12.5 Safari only ships the deprecated MediaQueryList.addListener
    // (Safari 14 added the modern .addEventListener); old Yandex Browser on
    // iPad iOS 12 used to throw a TypeError on .addEventListener and the
    // whole sidebar init bailed. Sentry TIMBRICA-FRONTEND-6Q.
    var mql=window.matchMedia('(min-width:769px)');
    var mqlChange=function(e){if(e.matches)closeSidebar()};
    if(mql.addEventListener)mql.addEventListener('change',mqlChange);
    else if(mql.addListener)mql.addListener(mqlChange);

    // (Active-tool centering is handled by revealCurrent() inside
    //  initGroups, which runs once the lazy-loaded groups are in the DOM.)

    // Prefetch pages on hover. Bind at init AND after the lazy groups inject
    // ('sidebar-loaded') so the tool links — not just the static system links —
    // get prefetch in browsers without Speculation Rules. Per-element _pf guard
    // prevents double-binding on re-run.
    var prefetched={};
    function bindPrefetch(root){
        _sbWhere = 'bindPrefetch';
        (root||nav).querySelectorAll('.sb-item[href]').forEach(function(a){
            if(a._pf)return;a._pf=1;
            // Не только наведение: на таче его нет, и мобильные оставались
            // вовсе без предзагрузки. `pointerdown` покрывает мышь и палец
            // одним событием — тот же момент, на котором срабатывает
            // `conservative` выше. Дедупликация по URL общая (`prefetched`),
            // так что два события не дают двух запросов.
            var _pfGo=function(){
                var h=this.href;
                if(prefetched[h]||this.classList.contains('active'))return;
                // Same-origin only: since the domain split the other-locale
                // link points at the sister domain (timbrica ↔ tembrica) and
                // cross-origin prefetch is CSP-blocked (default-src 'self') —
                // pure violation noise, zero benefit.
                if(h.indexOf(location.origin+'/')!==0)return;
                prefetched[h]=1;
                var link=document.createElement('link');
                link.rel='prefetch';
                link.href=h;
                document.head.appendChild(link);
            };
            a.addEventListener('mouseenter',_pfGo,{passive:true});
            a.addEventListener('pointerdown',_pfGo,{passive:true});
        });
    }
    bindPrefetch();
    window.addEventListener('sidebar-loaded',function(){bindPrefetch()});

    // ── Speculation Rules ──
    //
    // Два правила, и второе — из-за измеренного провала.
    //
    // `moderate` срабатывает по НАВЕДЕНИЮ мыши, а на тач-устройствах
    // наведения не существует. Замер 24.08: браузер правила ПРИНИМАЕТ
    // (CDP Preload: ruleSetUpdated без errorType, 55 источников), Speculation
    // Rules доступны у 91.2 % мобильных сессий — и при этом доля
    // активированных пререндеров (`pr` на session_start) была НОЛЬ из 724.
    // Ниже в этом же файле запасной `<link rel=prefetch>` тоже сидел на
    // `mouseenter` — то есть мобильные не получали НИКАКОГО предварительного
    // загружения, хотя составляют большинство трафика.
    //
    // `conservative` срабатывает на pointerdown/touchstart — то есть в момент,
    // когда человек УЖЕ жмёт ссылку. Поэтому широкий селектор здесь
    // безопасен: лишний пререндер возможен только если нажатие не перешло
    // в переход, а не «на всякий случай по всем ссылкам страницы».
    //
    // ⚠️ Исключения обязательны: пререндер ВЫПОЛНЯЕТ страницу, и для
    // адресов с побочным действием это не ускорение, а срабатывание:
    // /logout разлогинит, админка и касса — чужая территория.
    // ⚠️ Малформленный набор Chrome отвергает ЦЕЛИКОМ и молча — поэтому
    // приём проверяется тестом через CDP-домен Preload, а не глазами.
    try{
        if(HTMLScriptElement.supports&&HTMLScriptElement.supports('speculationrules')){
            var sr=document.createElement('script');
            sr.type='speculationrules';
            /* ⚠️ Нонс нужен, ХОТЯ в политике стоит 'inline-speculation-rules'
             * (заведено 23.08.2026). Замер 24.08: слово ничего не изменило для
             * тех, кто ломался. Chromium 110/111 шлёт отчёты «inline ←
             * sidebar.js» с той же частотой ДО и ПОСЛЕ его появления — 33+13
             * событий в сутки в обеих половинах (YaBrowser 23.3 corp и прочие
             * пиннутые сборки): у них правила предзагрузки не доезжали НИ РАЗУ
             * и не доедут от политики.
             *
             * Размер: 32 сессии в сутки из 49 060 — 0.065% трафика. Сами
             * старые сборки (yandex ≤23 / chrome ≤115) дают 1.5% сессий, но
             * блок ловят лишь ~4% из них. После нонса — 3 сессии в сутки
             * (25.08, первые полные сутки), −92%.
             *
             * ⚠️⚠️ Здесь 24.08 стояло «2.4% сессий сайта» — завышение в 35 раз.
             * Доля считалась по полю `ua` в analytics_events, а оно есть
             * ТОЛЬКО у диагностических событий (csp_violation, resource_error,
             * tool_error, feature_use): сессия попадает в такую выборку, лишь
             * если у неё что-то сломалось, — знаменателем были «сессии с
             * ошибкой», а не трафик. Честный источник — `session_start`,
             * `payload._ua` (`br`/`brv`), по одной строке на сессию.
             *
             * Почему именно они: до появления отдельной обработки
             * speculationrules движок видит просто инлайн-скрипт, а при нонсе
             * в политике 'unsafe-inline' по спецификации игнорируется — значит
             * пускает такой элемент ТОЛЬКО его собственный нонс. Нонс же
             * понимают все браузеры с CSP2 (2015), поэтому починка не зависит
             * от версии.
             *
             * ⚠️ Локально это НЕ воспроизводится: на современном движке набор
             * правил регистрируется и без нонса, и без ключевого слова
             * (проверено подменой заголовка + CDP Preload). Зелёный прогон на
             * рабочей машине здесь ничего не доказывает — прибор только
             * прод-отчёт. */
            if(CSPN)sr.nonce=CSPN;
            /* Пункт текущей страницы (`aria-current="page"`) не пререндерим: его
             * нажатие ничего не открывает (см. `sb_self_click` выше), а пререндер
             * той же страницы по наведению исполнял её целиком впустую — и он же
             * делал подмену мгновенной в чате 698. */
            sr.textContent=JSON.stringify({prerender:[
                {where:{selector_matches:'.sb-nav .sb-item[href]:not([aria-current="page"])'},eagerness:'moderate'},
                {where:{and:[
                    {href_matches:'/*'},
                    {not:{selector_matches:'[download],[target="_blank"],[data-no-prerender],[aria-current="page"]'}},
                    {not:{href_matches:'/*/logout'}},
                    {not:{href_matches:'/*/login*'}},
                    {not:{href_matches:'/*/register*'}},
                    {not:{href_matches:'/*/profile*'}},
                    {not:{href_matches:'/*/pro/*'}},
                    {not:{href_matches:'/pino*'}},
                    {not:{href_matches:'/api/*'}}
                ]},eagerness:'conservative'}
            ]});
            document.head.appendChild(sr);
        }
    }catch(e){}

    /* ── Полоса свёрнутого режима и раскрытие панели (docs/sidebar-mini.md) ──
     * Полоса — только при html.sb-mini (десктоп; класс ставит скрипт в <head>):
     * пингвин, поиск, «Мои генерации», закладки, новости и иконки рубрик. Иконки
     * строятся из разделов панели (.sb-grp) — один источник, ленивые рубрики
     * пересобирают полосу по sidebar-loaded. Нажатие по иконке раскрывает панель
     * поверх страницы (html.sb-peek) с этой рубрикой: она раскрыта и стоит у
     * верха списка; отступ страницы не меняется. Закрывается щелчком мимо, Esc,
     * сменой режима; переход по ссылке уносит её вместе со страницей. */
    var html=document.documentElement;
    var rail=document.getElementById('sbRail');
    var miniBtn=document.getElementById('sbMiniToggle');
    var miniSearch=document.getElementById('sbMiniSearch');
    var tip=document.getElementById('sbMiniTip');
    var desk=window.matchMedia?window.matchMedia('(min-width:769px)'):null;
    var tiles=[],curTile=null,hold=null,peekGroup=null,peekFrom=null,apReq=null;
    // Зовётся и из initGroups на старте — раньше, чем объявлены переменные выше.
    function miniOn(){
        return document.documentElement.classList.contains('sb-mini')&&
            !!(window.matchMedia&&window.matchMedia('(min-width:769px)').matches);
    }
    function peekOn(){return html.classList.contains('sb-peek')}
    function miniAe(f,d){try{if(window.__ae)window.__ae('feature_use',Object.assign({f:f},d||{}))}catch(e){}}

    function buildRail(){
        if(!rail)return;
        var gs=nav.querySelectorAll('.sb-grp[data-group]');
        rail.textContent='';tiles=[];curTile=null;
        if(!gs.length){buildLinkRail();return}
        gs.forEach(function(g){
            var b=document.createElement('button');
            b.type='button';b.className='sb-rail-btn';b.setAttribute('data-group',g.getAttribute('data-group'));
            var ico=g.querySelector('.sb-grp-ico');
            if(ico){var c=ico.cloneNode(true);c.removeAttribute('class');c.removeAttribute('style');b.appendChild(c)}
            /* Оттенок — с самого раздела: у .sb-grp тот же style="--h:…", что у
               иконки (ToolSidebarService, раздел тестера в layout). Не с <svg>:
               при выключенном SVG (Tor Browser, уровень «Safest» = svg.disabled)
               <svg> разбирается голым Element без .style — полоса падала на
               первой рубрике и оставалась пустой (Sentry QC). */
            var h=g.style.getPropertyValue('--h');if(h)b.style.setProperty('--h',h);
            var l=g.querySelector('.sb-grp-label'),n=g.querySelector('.sb-grp-count');
            b.setAttribute('aria-label',l?l.textContent.replace(/\s+/g,' ').trim():g.getAttribute('data-group'));
            if(n&&n.textContent.trim())b.setAttribute('data-n',n.textContent.trim());
            if(activeGroup&&g.getAttribute('data-group')===activeGroup)b.setAttribute('aria-current','true');
            rail.appendChild(b);
            tiles.push({b:b,g:g});
        });
        var cur=rail.querySelector('[aria-current]');if(cur)keepInRail(cur,true);
        if(peekGroup){var t=tileOfGroup(peekGroup);if(t)setCur(t)}
        observeGroups();
    }
    function tileOf(b){for(var i=0;i<tiles.length;i++)if(tiles[i].b===b)return tiles[i];return null}
    /* Раздел «Эксперты»: рубрик нет — полоса из пунктов его меню с иконками,
       прямыми ссылками (Фарид 16.10: «почему у экспертов сайдбар не свернуть»).
       Подпись — текст пункта без счётчика; непрочитанное — точкой на иконке. */
    function buildLinkRail(){
        nav.querySelectorAll('a.sb-item').forEach(function(a){
            var ico=a.querySelector('.sb-sys-icon svg');if(!ico)return;
            var label='';
            for(var n=a.firstChild;n;n=n.nextSibling){if(n.nodeType===3)label+=n.textContent}
            label=(label.trim()||a.textContent).replace(/\s+/g,' ').trim();
            var t=document.createElement('a');
            t.className='sb-rail-btn sb-rail-link';t.href=a.getAttribute('href');
            t.appendChild(ico.cloneNode(true));
            t.setAttribute('aria-label',label);
            if(a.classList.contains('sb-vc-on')||a.classList.contains('active'))t.setAttribute('aria-current','page');
            if(a.querySelector('.sb-vc-pending-badge,.sb-count-badge')){var d=document.createElement('span');d.className='sb-rail-dot';t.appendChild(d)}
            rail.appendChild(t);
        });
        var cur=rail.querySelector('[aria-current]');if(cur)keepInRail(cur,true);
    }

    function tileOfGroup(g){for(var i=0;i<tiles.length;i++)if(tiles[i].g===g)return tiles[i];return null}
    // «Туман» у иконки рубрики, показанной в раскрытой панели (CSS .is-cur).
    function setCur(t){
        if(curTile===t)return;
        if(curTile)curTile.b.classList.remove('is-cur');
        curTile=t;
        if(t){t.b.classList.add('is-cur');keepInRail(t.b,false)}
    }
    // Полоса листается сама, чтобы нужная иконка была видна; страница — нет.
    function keepInRail(b,center){
        if(!rail)return;
        var top=b.offsetTop,bot=top+b.offsetHeight,pad=20,r=rail;
        if(center)r.scrollTop=top-(r.clientHeight-b.offsetHeight)/2;
        else if(top-pad<r.scrollTop)r.scrollTop=top-pad;
        else if(bot+pad>r.scrollTop+r.clientHeight)r.scrollTop=bot+pad-r.clientHeight;
    }

    /* Раскрытая рубрика встаёт к верху списка и держится там, пока соседние
       разделы меняют высоту (прод 15.10: раздел над целью раскладывался уже
       ПОСЛЕ прокрутки и уводил её вниз, привязка прокрутки браузера сдвиг не
       гасила) — до первого прикосновения человека к списку или до поиска.
       Прокручивается только сам список, страница — никогда. */
    function holdTop(){
        if(!hold)return;
        if(nav.classList.contains('sb-searching')||!nav.clientHeight){hold=null;return}
        var want=Math.min(Math.max(0,hold.offsetTop-2),nav.scrollHeight-nav.clientHeight);
        if(Math.abs(nav.scrollTop-want)>1)nav.scrollTop=want;
    }
    var ro=window.ResizeObserver?new ResizeObserver(holdTop):null;
    function observeGroups(){if(!ro)return;ro.disconnect();nav.querySelectorAll('.sb-grp').forEach(function(g){ro.observe(g)})}
    ['wheel','touchstart','keydown','pointerdown'].forEach(function(ev){
        nav.addEventListener(ev,function(){hold=null},{passive:true});
    });

    function openPeek(t,kb){
        if(!peekOn()){
            peekFrom=document.activeElement;
            html.classList.add('sb-peek');
            miniAe('sidebar_peek',{g:t?(t.g.getAttribute('data-group')||''):'search'});
        }
        if(!t)return;
        // Рубрика, раскрытая прошлым нажатием, сворачивается обратно (рубрика
        // открытой страницы остаётся раскрытой — так она и стояла).
        if(peekGroup&&peekGroup!==t.g&&peekGroup.getAttribute('data-group')!==activeGroup)setOpen(peekGroup,false,true);
        peekGroup=t.g;
        setOpen(t.g,true,true);
        setCur(t);
        hold=t.g;holdTop();
        if(kb){var f=t.g.querySelector('.sb-grp-toggle');if(f){try{f.focus({preventScroll:true})}catch(e){}}}
    }
    function closePeek(back){
        if(!peekOn())return;
        html.classList.remove('sb-peek');
        hold=null;setCur(null);hideTip();
        if(back&&peekFrom&&peekFrom.focus){try{peekFrom.focus({preventScroll:true})}catch(e){}}
        peekFrom=null;
    }
    if(rail)rail.addEventListener('click',function(e){
        var b=e.target&&e.target.closest&&e.target.closest('.sb-rail-btn');
        if(!b)return;
        var t=tileOf(b);if(!t)return;
        hideTip();
        if(peekOn()&&curTile===t){closePeek(false);return}
        openPeek(t,e.detail===0);
    });
    // Щелчок мимо сайдбара и его панелей закрывает раскрытие; Esc — тоже.
    document.addEventListener('pointerdown',function(e){
        if(!peekOn())return;
        var x=e.target;
        if(x&&x.closest&&(x.closest('#toolSidebar')||x.closest('.sb-pop')))return;
        closePeek(false);
    },true);
    document.addEventListener('keydown',function(e){
        if(e.key==='Escape'&&peekOn()&&!document.querySelector('.sb-pop[data-pop-open="true"]'))closePeek(true);
    });

    /* ── Свёрнутый режим ─────────────────────────────────────────────────── */
    function syncMiniUi(){
        var on=html.classList.contains('sb-mini');
        if(miniBtn){
            var l=miniBtn.getAttribute(on?'data-l-expand':'data-l-collapse')||'';
            miniBtn.setAttribute('aria-pressed',on?'true':'false');
            if(l){miniBtn.setAttribute('aria-label',l);miniBtn.title=l}
        }
    }
    function setMini(on,why){
        html.classList.toggle('sb-mini',!!on);
        try{localStorage.setItem('sb_mini',on?'1':'0')}catch(e){}
        closePeek(false);hideTip();syncMiniUi();
        // Ширина страницы сменилась без resize окна, а широкий режим, карты и
        // холсты перемеряются по resize — даём им его.
        try{window.dispatchEvent(new Event('resize'))}catch(e){}
        if(on){var cur=rail&&rail.querySelector('[aria-current]');if(cur)keepInRail(cur,true)}
        else revealCurrent();
        miniAe('sidebar_mini',{on:on?1:0,why:why||'button'});
    }
    if(miniBtn)miniBtn.addEventListener('click',function(){setMini(!html.classList.contains('sb-mini'))});
    if(miniSearch)miniSearch.addEventListener('click',function(){
        openPeek(null,false);
        if(si){try{si.focus({preventScroll:true})}catch(e){si.focus()}}
    });

    /* ── Подсказка у полосы и у кнопок ряда управления ───────────────────── */
    // Своя, а не родной title: родной ждёт секунду и есть не у всех. У иконки
    // рубрики — её цвет и число инструментов; у ряда под панелью — над кнопкой.
    // Родной title на время наведения уходит в data-sb-title, чтобы не было двух.
    var canHover=window.matchMedia&&window.matchMedia('(hover:hover)').matches;
    var TIP_SEL='.sb-rail-btn,.sb-rail-sys a,.sb-rail-sys button,.sb-controls .sb-theme-btn,.sb-rail .sb-logo-link';
    function tipText(el){
        var t=el.getAttribute('title');
        if(t){el.setAttribute('data-sb-title',t);el.removeAttribute('title')}
        var s=el.getAttribute('data-sb-title')||el.getAttribute('aria-label')||'';
        if(el.id==='sbAuthBtn'){var nm=el.querySelector('.sb-auth-label');if(nm&&nm.textContent.trim())s=nm.textContent}
        return s.replace(/\s+/g,' ').trim();
    }
    function hideTip(){if(tip)tip.classList.remove('on')}
    function showTip(el){
        var text=tipText(el);
        if(!text||!tip||el.getAttribute('aria-expanded')==='true'){hideTip();return}
        var rubric=el.classList.contains('sb-rail-btn')&&el.hasAttribute('data-group'),h=rubric?el.style.getPropertyValue('--h'):'';
        tip.textContent='';
        if(rubric){var d=document.createElement('span');d.className='sb-tip-dot';tip.appendChild(d)}
        tip.appendChild(document.createTextNode(text));
        var n=rubric&&el.getAttribute('data-n');
        if(n){var c=document.createElement('span');c.className='sb-tip-n';c.textContent=n;tip.appendChild(c)}
        if(h)tip.style.setProperty('--h',h);else tip.style.removeProperty('--h');
        var above=!miniOn()&&!!el.closest('.sb-controls');
        tip.classList.toggle('above',above);
        tip.classList.add('on');
        var r=el.getBoundingClientRect(),rtl=getComputedStyle(sb).direction==='rtl',th=tip.offsetHeight,tw=tip.offsetWidth;
        if(above){
            var mid=r.left+r.width/2,left=Math.max(6,Math.min(window.innerWidth-tw-6,Math.round(mid-tw/2)));
            tip.style.top=Math.round(r.top-th-10)+'px';tip.style.left=left+'px';tip.style.right='auto';
            tip.style.setProperty('--ax',Math.round(mid-left)+'px');
            return;
        }
        tip.style.top=Math.max(4,Math.round(r.top+r.height/2-th/2))+'px';
        if(rtl){tip.style.left='auto';tip.style.right=Math.round(window.innerWidth-r.left+10)+'px'}
        else{tip.style.right='auto';tip.style.left=Math.round(r.right+10)+'px'}
    }
    if(canHover&&tip){
        sb.addEventListener('mouseover',function(e){
            var el=e.target&&e.target.closest&&e.target.closest(TIP_SEL);
            if(!el||!sb.contains(el)){hideTip();return}
            showTip(el);
        });
        sb.addEventListener('mouseleave',hideTip);
        sb.addEventListener('focusin',function(e){
            var el=e.target&&e.target.closest&&e.target.closest(TIP_SEL);
            if(el&&e.target.matches(':focus-visible'))showTip(el);
        });
        sb.addEventListener('focusout',hideTip);
        if(rail)rail.addEventListener('scroll',hideTip,{passive:true});
    }

    /* ── «Настройки» и меню аватара — панели у кнопок ряда управления ───────
     * Общий примитив anchored-popover (data-anchor="start"): место, переворот
     * над кнопкой, закрытие щелчком мимо и Esc. Модуль догружается при первом
     * наведении или фокусе; если первым пришло нажатие — ждём его и открываем. */
    function ensureAp(){
        if(window.__anchoredPopover)return Promise.resolve(window.__anchoredPopover);
        if(apReq)return apReq;
        var host=document.getElementById('sbSettings'),src=host&&host.getAttribute('data-ap-src');
        if(!src)return Promise.reject(new Error('anchored-popover: no src'));
        apReq=new Promise(function(res,rej){
            var s=document.createElement('script');
            s.src=src;if(CSPN)s.nonce=CSPN;
            s.onload=function(){window.__anchoredPopover?res(window.__anchoredPopover):rej(new Error('anchored-popover: no api'))};
            s.onerror=function(){apReq=null;rej(new Error('anchored-popover: load failed'))};
            document.head.appendChild(s);
        });
        return apReq;
    }
    function wirePop(btn,panel){
        if(!btn||!panel)return;
        var warm=function(){ensureAp().then(function(ap){ap.scan(document)}).catch(function(){})};
        btn.addEventListener('pointerenter',warm,{once:true});
        btn.addEventListener('focus',warm,{once:true});
        btn.addEventListener('click',function(e){
            hideTip();
            if(window.__anchoredPopover)return;
            // Модуля ещё нет: родное «открыть по popovertarget» поставило бы
            // панель посреди экрана — ждём модуль и открываем у кнопки.
            e.preventDefault();
            ensureAp().then(function(ap){
                ap.scan(document);
                if(ap.tier===3){if(panel.__apManual)panel.__apManual(true,btn);return}
                ap.anchorTo(panel,btn);
                try{panel.showPopover()}catch(_){}
                if(e.detail===0){var f=panel.querySelector('a[href],button,input');if(f){try{f.focus({preventScroll:true})}catch(_){}}}
            }).catch(function(){try{panel.showPopover()}catch(_){}});
            miniAe('sidebar_pop',{id:panel.id});
        });
    }
    wirePop(document.getElementById('sbSettingsBtn'),document.getElementById('sbSettings'));
    var meBtn=document.getElementById('sbAuthBtn');
    if(meBtn&&meBtn.tagName==='BUTTON')wirePop(meBtn,document.getElementById('sbMe'));
    // Гостевая «Аккаунт» (до 20.10 — «Войти») ведёт на страницу Премиума: до неё
    // нажатие не считалось вовсе, и о кнопке решали без единого числа. Счёт —
    // sb_account_click; покупка после неё помечена источником sidebar-account.
    if(meBtn&&meBtn.tagName==='A'&&meBtn.classList.contains('sb-signin')){
        meBtn.addEventListener('click',function(){
            if(!meBtn.classList.contains('sb-signin'))return; // the page has since learned the visitor is signed in
            try{if(window.__proSrc)window.__proSrc.set('sidebar-account')}catch(_){}
            miniAe('sb_account_click',{});
        });
    }

    // «Шрифт для дислексии» — переключатель в «Настройках» (до 15.10 — кнопка в
    // подвале). Состояние при загрузке ставит скрипт в <head> (a11y_dyslexia).
    var dys=document.getElementById('sbDyslexia');
    if(dys){
        dys.checked=html.getAttribute('data-dyslexia')==='1';
        dys.addEventListener('change',function(){
            if(dys.checked)html.setAttribute('data-dyslexia','1');else html.removeAttribute('data-dyslexia');
            try{localStorage.setItem('a11y_dyslexia',dys.checked?'1':'0')}catch(e){}
            miniAe('a11y_dyslexia',{on:dys.checked?1:0});
        });
    }

    window.addEventListener('sidebar-loaded',buildRail);
    if(desk){
        var deskChange=function(){if(!desk.matches){closePeek(false);hideTip()}syncMiniUi()};
        if(desk.addEventListener)desk.addEventListener('change',deskChange);
        else if(desk.addListener)desk.addListener(deskChange);
    }
    buildRail();syncMiniUi();
})();
